<template>
  <div>
    <div class="mb-2">{{ name }}</div>
    <a @click="setDeparture" class="button-secondary block p-1 mb-2" :class="{ disabled: !busstop.enableBoarding }">{{$t('tour_set_departure')}}</a>
    <a @click="setArrival" class="button-secondary block p-1 mb-2" :class="{ disabled: !busstop.enableDropOff }">{{$t('tour_set_arrival')}}</a>
    <a @click="showDetail" class="button-secondary block p-1" :class="{ disabled: isBlankBusstop }">{{$t('tour_bus_info')}}</a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  methods: {
    setDeparture: function () {
      this.$store.dispatch('reservation/updateDeparture', this.busstop)
    },
    setArrival: function () {
      this.$store.dispatch('reservation/updateArrival', this.busstop)
    },
    showDetail: function () {
      this.$store.dispatch('reservation/updateDetailMode')
    }
  },
  computed: {
    ...mapGetters({
      busstop: 'drawer/getTarget',
    }),
    name: function () {
      const { name } = this.busstop
      const s = name && name.length > 8 ? name.substring(0, 8) + '...' : name

      return s
    },
    isBlankBusstop: function () {
      return this.busstop.name === undefined
    }
  }
}
</script>
